import { parseFcmPushPayload } from './fcmPushPayload';

/** Normalize inbox rows, FCM payloads, SW click data, and socket push payloads. */
export const normalizePortalNotificationSource = (source = {}) => {
  if (!source || typeof source !== 'object') {
    return {};
  }

  if (source.data && typeof source.data === 'object' && (source.notification || source.messageId)) {
    const parsed = parseFcmPushPayload(source);
    return {
      ...parsed.data,
      type: parsed.type,
      eventId: parsed.eventId,
      targetId: parsed.data?.targetId ?? parsed.eventId ?? null,
      targetType: parsed.data?.targetType ?? null,
      id: parsed.notificationId,
      notificationId: parsed.notificationId,
    };
  }

  const rawData = source?.data ?? {};
  if (
    rawData &&
    typeof rawData === 'object' &&
    Object.keys(rawData).length > 0 &&
    !source.type &&
    !source.targetType &&
    !source.id &&
    !source.notificationId
  ) {
    return { ...rawData, ...source };
  }

  return source;
};

export const isPortalNotificationUnread = (source = {}) => source?.read !== true;
